import { Outlet } from 'react-router-dom';
import { Notifications } from '@mantine/notifications';
import { NavigationHistoryProvider } from '@/hooks/useNavigationHistory';
import useAccessToken from '@/hooks/useAccessToken';
import { useEventSource, useEventSourceListener } from '@react-nano/use-event-source';
import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import SSEHandler from '@/components/SSEHandler';
import { ModalQueueProvider } from '@/hooks/FileUploadResponseContext';
import vars from '@/config/vars';
import styles from './style.module.css';

const DefaultLayout = () => {
  const [event, setEvent] = useState();
  const { isLoading } = useAccessToken();
  const queryClient = useQueryClient();

  const [eventSource] = useEventSource(vars.request.sseUrl, true);

  useEventSourceListener(
    eventSource,
    ['error', 'message'],
    async (e) => setEvent(e),
    [],
  );

  // A new event was created for the user: refresh the open events count in the menu
  useEventSourceListener(
    eventSource,
    ['intakeEvent'],
    () => queryClient.invalidateQueries({ queryKey: ['intakeEvent', 'openCount'] }),
    [],
  );

  if (isLoading) {
    return '';
  }

  return (
<ModalQueueProvider>
    <NavigationHistoryProvider>
  <div className={styles.layout}>
      <Notifications position='bottom-left' className={styles.notifications} zIndex={250} />
    <main>
      <Outlet />
      <SSEHandler event={event} />
    </main>
      </div>
      </NavigationHistoryProvider>
      </ModalQueueProvider>
  );
};

export default DefaultLayout;
